import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { ICountdownProps } from './types';

export const Countdown = (props: ICountdownProps) => {
  const { message } = props;

  return <UIText2 color="gray60_100">{message}</UIText2>;
};
